import React, { Component } from 'react';
import PropTypes from 'prop-types';
import wrapReact from '../../../../util/react';

export default function CompWrapper(Comp, name) {
  class wrapComp extends Component {
    handleClick = ({ key }) => {
      const { changeLanguage } = this.props;
      changeLanguage(key);
    };

    changeLang = () => {
      const { intl } = this.props;
      switch (intl.locale) {
        case 'en':
          return 'English';
        case 'de':
          return 'Deutsch';
        default:
          return 'English';
      }
    };

    render() {
      return (
        <Comp
          {...this.props}
          onClick={this.handleClick}
          title={this.changeLang()}
        />
      );
    }
  }
  wrapComp.propTypes = {
    changeLanguage: PropTypes.func.isRequired,
    intl: PropTypes.shape({
      locale: PropTypes.string.isRequired,
    }).isRequired,
  };
  return wrapReact(wrapComp, name);
}
